import { REPORT_TYPE_IDS } from "../../../store/constants";
import AnnualDataQuality from "./AnnualDataQuality";

const AnnualExecutiveSummary = () => (
  <AnnualDataQuality
    reportTypeId={REPORT_TYPE_IDS.annual_executive_queue_performance_summary}
    title="Annual Executive Queue Performance Summary"
    description="Annual executive scorecard for demand, outcomes, waits, service time, peaks, and operating exceptions."
    emptyDataMessage="Annual Executive Summary data is empty for the selected year."
    searchPrompt="Update filters and hit Search to retrieve annual Executive Summary data."
  />
);

export default AnnualExecutiveSummary;
